const getDefaultsFromPostinstall = () => ({
  "config": {
    "apiKey": "AIzaSyA3H8XcpOvtiSOVea-jf9QVOKqSRXMy9DQ",
    "appId": "1:429721281782:web:a3b72a0e338400dc4878d7",
    "authDomain": "anybuddy-91142.firebaseapp.com",
    "databaseURL": "https://anybuddy-91142-default-rtdb.europe-west1.firebasedatabase.app",
    "messagingSenderId": "429721281782",
    "projectId": "anybuddy-91142",
    "storageBucket": "anybuddy-91142.appspot.com"
  },
  "emulatorHosts": {}
});
export { getDefaultsFromPostinstall };